export default __webpack_public_path__ + "static/210526_妲絲刷關活動熱更完成_kr-76870b903da88e83bbaa33c182d8b2e8.webp";